const testUpload = {
    title: 'Test Data Upload',
    description: 'Bulk upload development and test documents.',
    incidentDirectory: 'Incident file directory: /upload_data/incident file/',
    quickUpload: 'Quick Upload',
    selectIncidentFiles: 'Select incident files and upload',
    quickUploadHelp: 'Metadata is set automatically when you select incident files.',
    detailedUpload: 'Detailed Upload',
    category: 'Category',
    categories: {
      incident: 'Incidents',
      finance: 'Finance',
      planning: 'Planning',
      analytics: 'Analytics',
      engineering: 'Engineering',
    },
    selectFiles: 'Select files',
    selectedFiles: 'Selected files: {{count}}',
    startUpload: 'Start upload',
    uploading: 'Uploading...',
    results: 'Upload Results',
    successCount: 'Succeeded: {{count}}',
    failureCount: 'Failed: {{count}}',
    succeededFiles: 'Succeeded files:',
    failedFiles: 'Failed files:',
    instructionsTitle: 'How to use:',
    instructions: {
      quick: 'Click "Select incident files and upload" to bulk upload incident files.',
      detailed: 'Or use "Detailed Upload" to choose a category and upload files.',
      metadata: 'Metadata is generated automatically from file names for incident files.',
      review: 'After upload, review the files on the documents page.',
    },
  };

export default testUpload;
